const routeWorkspaceBundleCache = new Map();

// Bundles hold the workspace's full entity snapshots (thousands of emoji rows),
// so keep only the most recently hydrated workspaces. An evicted workspace just
// falls back to the loading fallback on its next visit.
const MAX_CACHED_WORKSPACE_BUNDLES = 8;

export function cacheRouteWorkspaceBundle(bundle) {
  const workspaceId = bundle?.workspaceId ? String(bundle.workspaceId) : null;
  if (!workspaceId || String(bundle.workspace?.id) !== workspaceId) return null;
  if (bundle.profile && String(bundle.profile.workspace_id) !== workspaceId) return null;
  if (bundle.entitySnapshots && String(bundle.entitySnapshots.workspace_id) !== workspaceId) return null;

  const cachedBundle = routeWorkspaceBundleCache.get(workspaceId);
  // Retained pane providers skip entity reads; do not let them erase a fuller bundle.
  const entitySnapshots = bundle.entitySnapshots || cachedBundle?.entitySnapshots || null;
  // Callers cache from render; skip the write when nothing changed so re-renders
  // neither churn the Map nor reorder eviction recency.
  if (
    cachedBundle &&
    cachedBundle.workspace === bundle.workspace &&
    cachedBundle.profile === (bundle.profile || null) &&
    cachedBundle.user === (bundle.user || null) &&
    cachedBundle.entitySnapshots === entitySnapshots
  ) {
    return cachedBundle;
  }

  const nextBundle = {
    workspaceId,
    workspace: bundle.workspace,
    profile: bundle.profile || null,
    user: bundle.user || null,
    entitySnapshots,
  };
  routeWorkspaceBundleCache.delete(workspaceId);
  routeWorkspaceBundleCache.set(workspaceId, nextBundle);
  if (routeWorkspaceBundleCache.size > MAX_CACHED_WORKSPACE_BUNDLES) {
    routeWorkspaceBundleCache.delete(routeWorkspaceBundleCache.keys().next().value);
  }
  return nextBundle;
}

export function cachedRouteWorkspaceBundle(workspaceId, { requireProfile = true, includeEntitySnapshots = false } = {}) {
  const normalizedWorkspaceId = workspaceId ? String(workspaceId) : null;
  if (!normalizedWorkspaceId) return null;

  const bundle = routeWorkspaceBundleCache.get(normalizedWorkspaceId) || null;
  if (requireProfile && !bundle?.profile) return null;
  if (includeEntitySnapshots && !bundle?.entitySnapshots) return null;
  return bundle;
}
